import angular from 'angular';
import Menu from './menu/menu.module';
import AdminMenu from './admin-menu/admin-menu.module';
import Countries from './countries/countries.module';
import Timezones from './timezones/timezones.module';

let componentModule = angular.module('app.componentModule', [
    Menu,
    AdminMenu,
    Countries,
    Timezones
])
.name;

export default componentModule;


// WEBPACK FOOTER //
// ./src/app/components/components.js